import { gql } from '@apollo/client';
import orgsAndUnitsFragment from '../../shared/queries/orgsAndUnitsFragment';
import legalDocumentFragment from './legalDocumentFragment';

const GET_LEGAL_DOCUMENTS = gql`
  query GetLegalDocuments($orgId: Int!, $isActive: Boolean!) {
    legalDocuments(orgId: $orgId) {
      ...LegalDocumentFields
    }

    mddapOrganization(id: $orgId, isActive: $isActive) {
      ...OrgAndUnitsFields
    }
  }
  ${orgsAndUnitsFragment}
  ${legalDocumentFragment}
`;

export default GET_LEGAL_DOCUMENTS;
